import { Actions } from './actions';
import { GET_BLACK_LIST_ERROR, GET_BLACK_LIST_REQUEST, GET_BLACK_LIST_SUCCESS } from './constants';

export const initialState = {
  reports: [] as any,
  loading: false as boolean,
  error: null as null | Error,
};

export type BlackListState = typeof initialState;

export const BlackListReducer = (state: BlackListState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_BLACK_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
        reports: [],
      };
    }
    case GET_BLACK_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        reports: action.payload,
      };
    }
    case GET_BLACK_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
};
